<template>
  <section class="default-container">
    <BreadCrumb :bread-crumb="breadCrumb" />
    <div class="content">
      <div class="content-left">
        <div class="left-title">KPI 도서</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div v-for="(subMenu, idx) in menu.subMenu" :key="'subMenu' + idx" :class="['sub-menu__item', {on: subMenu.selected}]">
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <div class="book-list">
          <div v-for="book in bookList" :key="'book' + book.id" class="book-item" @click="goBookDetail(book.id)">
            <img :src="book.imgPath" alt="bookImg" class="book-img" />
            <div class="book-item__right">
              <div class="book-title is-18m">{{ book.title }}</div>
              <div class="is-14r"><strong>저자</strong> : {{ book.writer }}</div>
              <div class="is-14r"><strong>출판사</strong> : {{ book.publication }}</div>
              <div class="is-14r"><strong>발행</strong> : {{ book.publisher }}</div>
              <div class="is-14r"><strong>발행일</strong> : {{ book.publicationDate }}</div>
              <div class="is-14r"><strong>면수</strong> : {{ book.numberOfPages }}</div>
              <div class="is-14r"><strong>규격</strong> : {{ book.specification }}</div>
              <div class="is-14r"><strong>금액</strong> : {{ comma(book.price) }}원</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BreadCrumb from '~/components/common/BreadCrumb.vue'
import {useKpiBookStore} from '~/store/kpi-book/index.js'
import {comma} from '~/utils/function.js'
import {useHead} from '#imports'

export default {
  name: 'KpiBookIndex',
  components: {BreadCrumb},
  setup() {
    const store = useKpiBookStore()
    // 사이트 링크용 메타 태그 설정
    useHead({
      title: 'KPI 도서  | 한국인사관리협회',
      meta: [
        {
          name: 'description',
          content: '한국인사관리협회가 직접 발행한 전문 도서들을 소개합니다. 조직 운영에 필요한 깊이 있는 인사이트를 얻으세요.'
        },
        {
          property: 'og:title', // Open Graph 태그 (카카오톡, 페이스북 등 공유 시 미리보기 제목)
          content: 'KPI 도서  | 한국인사관리협회'
        },
        {
          property: 'og:description', // Open Graph 태그 (공유 시 미리보기 설명)
          content: '한국인사관리협회가 직접 발행한 전문 도서들을 소개합니다. 조직 운영에 필요한 깊이 있는 인사이트를 얻으세요.'
        }
      ],
      // 쿼리 파라미터가 붙더라도 항상 이 URL이 표준임을 알립니다.
      link: [
        { rel: 'canonical', href: 'https://insabank.com/kpi-book' }
      ]
    })
    return {store}
  },
  data() {
    return {
      breadCrumb: ['홈', 'KPI 도서'],
      comma,
      menuList: [
        {
          name: 'KPI 도서',
          selected: false,
          subMenuShow: false,
          subMenu: [{name: 'KPI 도서 리스트', selected: false}]
        }
      ],
      bookList: [
        {
          id: 0,
          title: '',
          imgPath: '',
          previewFilePath: '',
          publisher: '',
          writer: '',
          publication: '',
          publicationDate: '',
          numberOfPages: 0,
          specification: '',
          price: 0
        }
      ]
    }
  },
  watch: {},
  mounted() {
    this.getKpiBookList()
  },
  methods: {
    goBookDetail(bookId) {
      this.$router.push(`/kpi-book/${bookId}`)
    },
    async getKpiBookList() {
      try {
        const {data} = await this.store.getKpiBookList()
        this.bookList = data
      } catch (error) {
        console.log(error)
        alert('오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
      }
    }
  }
}
</script>

<style scoped lang="scss">
.default-container {
  padding: 48px 0 100px;
  .content {
    display: flex;
    gap: 24px;
    position: relative;
    .content-left {
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;
      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }
      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;
        &:hover {
          color: #0058aa;
        }
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }
      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }
        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }
        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }
    .content-right {
      width: 100%;
      .book-list {
        .book-item {
          cursor: pointer;
          padding: 24px;
          display: flex;
          gap: 16px;
          border-bottom: 1px solid #dbdbdb;

          .book-img {
            width: 142.427px;
            height: 210px;
          }
          .book-item__right {
            .book-title {
              margin-bottom: 12px;
            }
            .is-14r {
              color: #909090;
              margin-bottom: 4px;
              strong {
                color: #121212;
              }
            }
          }
        }
      }
    }
  }
}
</style>
